// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-" + {"318":"cf81caf1de9b265e2977","669":"f03e4d6db2f0743a8a22","795":"31bd07e08fed66dfaff6","796":"0c7e28b539acf636a29c","820":"08f503d5cfdb1071d4b9"}[chunkId] + ".js";
};